import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, formatters, defaultProps } from '@src/services/theme';
import { ProtoList, PropsList, StateList } from '@src/components/Proto';
import { Ratio, Box } from '@src/components';

// typing
interface LocalProps extends PropsList {
    filters?: any;
}

// style
const style = css`
`;

// component
export class BatteryList extends ProtoList<LocalProps, StateList> {
    
    componentWillReceiveProps(props) {
        this.loadWhenFiltersChanged( props, this.props );
    }

	// render
	render() {
        const _loading = this.loading();
        if (_loading) return _loading;
        const { onBattery } = this.props;
        const { loading, items = [], tableProps } = this.state;
        //const { data } = this.state.data;

        const columns = [
            { Header: _('batterylist_colgroup_battery', 'Fleet'), columns: [
                { Header: _('batterylist_col_description', 'Fleet'), accessor: 'battery.id', className: "id" },
                { Header: _('batterylist_col_batterytype', 'Fleet'), accessor: 'battery.batterytype' },
                { Header: _('batterylist_col_serialno', 'Fleet'), accessor: 'battery.serialno', Cell: (row) => (
                    <a className="download">
                        {row.original.battery.serialno}
                    </a>
                ) },
                { Header: _('batterylist_col_nominalvoltage', 'Fleet'), accessor: 'battery.nominalvoltage', className: "number" },
                { Header: _('batterylist_col_nominalcapacity', 'Fleet'), accessor: 'battery.nominalcapacity', className: "number" },
            ]},
            { Header: _('batterylist_colgroup_truck', 'Fleet'), columns: [
                { Header: _('batterylist_col_new', 'Fleet'), id: 'is_new', accessor: v => formatters.yesNo(v.is_new) },
                { Header: _('batterylist_col_trucktype', 'Fleet'), accessor: 'truck.type' },
                { Header: _('batterylist_col_trucksn', 'Fleet'), accessor: 'truck.serialno' },
                { Header: _('batterylist_col_truckbrand', 'Fleet'), accessor: 'truck.brand' },
                { Header: _('batterylist_col_truckmodel', 'Fleet'), accessor: 'truck.model' },
            ]},
            { Header: _('batterylist_colgroup_battery_info', 'Fleet'), columns: [
                { Header: _('batterylist_col_cycles', 'Fleet'), accessor: 'battery_information.cycles', className: "number" },
                { Header: _('batterylist_col_soh', 'Fleet'), accessor: 'battery_information.soh', className: "number" },
            //{ Header: _('batterylist_colgroup_days', 'Fleet'), accessor: 'battery_information.last_contact_diff' },
                { Header: _('batterylist_col_dof', 'Fleet'), accessor: 'battery_information.days_on_field' },
                { Header: _('batterylist_col_alarm', 'Fleet'), accessor: 'battery_information.last_alert.description' },
                { Header: _('batterylist_col_status', 'Fleet'), id: 'status', accessor: v => formatters.status(!v.battery_information.last_alert ? 2 : v.battery_information.last_alert.class === "warning" ? 1 : 0), className: "bullet"},
                { Header: _('batterylist_col_actions_required', 'Fleet'), accessor: 'battery_information.last_alert.action_required' },
            ]},
        ];
        
        const localTableProps = {
            ...defaultProps.table(),
            ...tableProps,
            getTrProps: (state, row, column) => {
                if (!row) return {};
                return {
                    className: classNames("clickable"),
                    onClick: (e) => {
                        if (onBattery) onBattery({id: row.original.battery.id})
                    },
                };
            }
        }
        localTableProps.loading = loading;
      
		return (
            <Box title={_('batterylist_title', 'Fleet')} collapsed={false}>
                <div className={style}>
                    <ReactTable
                        {...localTableProps}
                        data={items}
                        columns={columns}
                    />
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Fleet/BatteryList.tsx